import {CommercialDimensions} from '@domain/commercial-dimensions';
import {Pattern} from '@domain/pattern';
import {CutbarsLength} from '@domain/production-schedule/cutbars-length';
import {DrawingType} from '@domain/production-schedule/drawing-type.enum';
import {ManualNonProductionItemDrawing} from '@domain/production-schedule/manual-non-production-item-drawing';
import {ProductionScheduleItemInPathGroup} from '@domain/production-schedule/production-schedule-item-in-path-group';
import {AssertionUtils} from '@vdw/angular-component-library';
import {TechnicalDimensions} from '../technical-dimensions';
import {ProductionScheduleItemInPathGroupStatus} from './production-schedule-item-in-path-group-status';
import {ProductionScheduleItemRecolorInformation} from './production-schedule-item-recolor-information';

export class JuteProductionScheduleItemInPathGroup extends ProductionScheduleItemInPathGroup {
  private _pattern: Pattern;

  public constructor(
    drawing: ManualNonProductionItemDrawing,
    commercialDimensionsInMM: CommercialDimensions,
    technicalDimensions: TechnicalDimensions,
    mainColorPosition: number,
    borderColorPosition: number,
    guid: string,
    amountProduced: number,
    status: ProductionScheduleItemInPathGroupStatus,
    id: number = null,
    epId: number = null,
    totalWovenHeightInPicks: number = null,
    totalWovenHeightInMM: number = null,
    amountIncomplete: number = null
  ) {
    super(
      drawing,
      1,
      commercialDimensionsInMM,
      technicalDimensions,
      false,
      mainColorPosition,
      borderColorPosition,
      guid,
      amountProduced,
      status,
      DrawingType.MANUAL_NON_PRODUCTION_ITEM,
      null,
      id,
      epId,
      totalWovenHeightInPicks,
      totalWovenHeightInMM,
      amountIncomplete
    );

    this._pattern = drawing.pattern;
  }

  public get pattern(): Pattern {
    return this._pattern;
  }

  public static fromJSON(productionScheduleItemInPathGroupJSON: any): JuteProductionScheduleItemInPathGroup {
    let manualNonProductionItemDrawing = ManualNonProductionItemDrawing.fromJSON(productionScheduleItemInPathGroupJSON.design);
    manualNonProductionItemDrawing.pattern = Pattern.fromJSON(productionScheduleItemInPathGroupJSON.pattern);
    return new JuteProductionScheduleItemInPathGroup(
      manualNonProductionItemDrawing,
      productionScheduleItemInPathGroupJSON.commercialDimensions,
      productionScheduleItemInPathGroupJSON.technicalDimensions,
      productionScheduleItemInPathGroupJSON.mainColorPosition,
      productionScheduleItemInPathGroupJSON.borderColorPosition,
      null,
      productionScheduleItemInPathGroupJSON.amountProduced,
      AssertionUtils.isNullOrUndefined(productionScheduleItemInPathGroupJSON.status) ? null : ProductionScheduleItemInPathGroupStatus[`${productionScheduleItemInPathGroupJSON.status}`],
      productionScheduleItemInPathGroupJSON.id,
      productionScheduleItemInPathGroupJSON.epId,
      productionScheduleItemInPathGroupJSON.nrWovenInPicks,
      productionScheduleItemInPathGroupJSON.nrWovenInMM,
      productionScheduleItemInPathGroupJSON.amountIncomplete
    );
  }

  public getCommercialCutbarsLengthInMM(): number {
    return 0.0;
  }

  public getTechnicalCutbarsLengthInNumberOfPicks(): number {
    return 0;
  }

  public getCutbarInformation(): CutbarsLength {
    return {
      cutbarBefore: {
        commercialLengthInMM: 0,
        technicalLengthInNumberOfPicks: 0
      },
      cutbarAfter: {
        commercialLengthInMM: 0,
        technicalLengthInNumberOfPicks: 0
      }
    };
  }

  public canBeRecolored(): boolean {
    return false;
  }

  public hasCutbarBefore(): boolean {
    return false;
  }

  public hasCutbarAfter(): boolean {
    return false;
  }

  public toJSON(): JSON {
    const result = super.toJSON();

    result['pattern'] = this._pattern.toJSON();

    return result;
  }

  public recolorDrawing(recolorInformation: ProductionScheduleItemRecolorInformation): void {
    throw new Error('RecolorDrawing not supported.');
  }
}
